// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__97FuE","footerGit":"Footer_footerGit__Gn3mh","svgWrapperGit":"Footer_svgWrapperGit__7QB4-"};